import React from "react";
import { useGetOfmSchedulersQuery } from "@/services/ofm-extract";
import SchedulerJobs from "../scheduler-jobs";
import OfmSchedulersList from "components/ofm-schedulers-list";

export default function Schedulers() {
  const {
    data,
    isFetching,
    refetch,
  } = useGetOfmSchedulersQuery(
    undefined,
    {
      pollingInterval: 15000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }
  );
  const [open, setOpen] = React.useState<Record<string, boolean>>({});

  const items = data?.items ?? [];

  return (
    <OfmSchedulersList
      items={items}
      isLoading={isFetching}
      onRefresh={() => refetch()}
      open={open}
      onToggle={(id: string) => setOpen((m) => ({ ...m, [id]: !m[id] }))}
      renderExpanded={(id: string, codInvoiceModel?: string) => <SchedulerJobs schedulerId={id} codInvoiceModel={codInvoiceModel} />}
    />
  );
}
